<div [formGroup]="formGroupPhone" class="tw-flex tw-row-2" style="justify-content: center">
    <mat-form-field class="tw-input-width" appearance="outline" style="margin: 0 20px">
        <mat-label>{{'client.phone.type' | translate}}</mat-label>
        <mat-select formControlName="type">
            <mat-option value="MAISON">{{'client.phone.typeOptions.maison' | translate}}</mat-option>
            <mat-option value="TRAVAIL">{{'client.phone.typeOptions.travail' | translate}}</mat-option>
            <mat-option value="CELL">{{'client.phone.typeOptions.cell' | translate}}</mat-option>
            <mat-option value="OTHER">{{'client.phone.typeOptions.autre' | translate}}</mat-option>
        </mat-select>
        <mat-error>
            <tw-form-error-message [errors]="formGroupPhone.controls['type'].errors"></tw-form-error-message>
        </mat-error>
    </mat-form-field>
    <mat-form-field class="tw-input-width" appearance="outline" style="margin: 0 20px">
        <mat-label>{{'client.phone.telephone' | translate}}</mat-label>
        <input matInput required formControlName="number" autocomplete='tel' twMyNumberOnly>
        <mat-error>
            <tw-form-error-message [errors]="formGroupPhone.controls['number'].errors"></tw-form-error-message>
        </mat-error>
    </mat-form-field>
</div>
